<h2 mat-dialog-title>Add New Packet Template</h2>

<mat-dialog-content>
    <mat-card appearance="outlined" telemetry="Card-NewPacketTemplate-UtilityBilling" [formGroup]="formGroup">
        <mat-card-content fxLayout="column" fxLayoutAlign="space-around stretch">

            <lgd-select controlName="module" label="Module" placeholder="Select Module" [options]="modulesObservable">
            </lgd-select>

            <lgd-select controlName="process" label="Process" [placeholder]="processPlaceholder"
                        [options]="processesObservable">
            </lgd-select>

            <div fxLayout="row" fxLayoutAlign="space-between start">
                <lgd-text fxFlex controlName="description" label="Packet Description">
                </lgd-text>

                <button mat-icon-button matTooltip="Insert Date Token" [matMenuTriggerFor]="menu">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                    <ng-container *ngFor="let option of menuOptions; last as isLast">
                        <button mat-menu-item (click)="addToken(option)">{{option.Key}}</button>
                        <mat-divider></mat-divider>
                    </ng-container>
                </mat-menu>
            </div>
        </mat-card-content>

        <mat-progress-bar *ngIf="isSaving" mode="indeterminate"></mat-progress-bar>
    </mat-card>

</mat-dialog-content>

<mat-dialog-actions fxFlexLayout="end start">
    <button mat-button mat-dialog-close>Cancel</button>

    <button mat-button color="primary" (click)="saveTemplate()" [disabled]="!canSave"
            telemetry="Submission-Save-NewPacketTemplate-UtilityBilling">
        Save
    </button>
</mat-dialog-actions>